import type { ResourceSpecifier } from './ast';

const projectScopedResources = [
  'agent-graph',
  'agent-optimization',
  'ai-dataset',
  'ai-model-config',
  'ai-tool',
  'prompt-snippet',
  'alert',
  'ai-evaluation',
  'context-kind',
  'env',
  'error',
  'goal',
  'layer',
  'log',
  'metric',
  'metric-group',
  'observability-dashboard',
  'observability-settings',
  'payload-filter',
  'release-pipeline',
  'release-policy',
  'session',
  'trace',
  'vega',
  'view',
] as const satisfies Array<ResourceSpecifier['type']>;

export type ProjectScopedResource = Extract<ResourceSpecifier, { type: (typeof projectScopedResources)[number] }>;

export const isProjectScopedResourceType = (resourceType: ResourceSpecifier['type']) =>
  (projectScopedResources as readonly string[]).includes(resourceType);

export const isProjectScopedResource = (resource: ResourceSpecifier): resource is ProjectScopedResource =>
  isProjectScopedResourceType(resource.type);
